var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 19 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 2.99375H9.71094L6.96172 0.364062C6.92674 0.331315 6.88073 0.312911 6.83281 0.3125H0.875C0.460156 0.3125 0.125 0.647656 0.125 1.0625V14.9375C0.125 15.3523 0.460156 15.6875 0.875 15.6875H18.125C18.5398 15.6875 18.875 15.3523 18.875 14.9375V3.74375C18.875 3.32891 18.5398 2.99375 18.125 2.99375ZM17.1875 14H1.8125V2H6.23047L9.03359 4.68125H17.1875V14Z",
    fill: "#2A5578"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.6893624c531dcf1dcb27d3eeb127cf84.svg";
export { ForwardRef as ReactComponent };